import Image from './Image'

class Backdrop extends Image {}

export default Backdrop
